var barcode = {

	_enabled: true,
	$inputElement: null,
	scannerOptions: null,
	onSubmitCallback: null,
	onBlurHandler: null,
	onPasteHandler: null,
	onKeydownHandler: null,

	init: function ($inputElement, onSubmitCallback, focusFunction) {

		var $this = this;
		this.$inputElement = $inputElement;
		this.onSubmitCallback = onSubmitCallback;

		$inputElement.cursorFocus();

		// --- Define Handlers ---
		this.onBlurHandler = typeof focusFunction == "function" ? focusFunction : function () {
			var blurEl = $(this);
			setTimeout(function() {
				blurEl.cursorFocus()
			}, 500);
		};

		this.onPasteHandler = function () {
			var element = this;
			setTimeout(function () {
				$this.onSubmitCallback($(element).val());
			}, 100);
		};

		this.onKeydownHandler = function (e) {
			// This handler is for manual entry in the main input when scanner is disabled
			if (e.which === 13 && !$this._enabled) {
				e.preventDefault();
				$this.onSubmitCallback($(this).val());
			}
		};

		this.scannerOptions = {
			onComplete: function(string){
				console.log('scanned: ' + string);
				// Use the stored callback
				$this.onSubmitCallback($(this).val());
			}
		};

		// Initial setup
		this.enable();
	},

	enable: function() {
		if (this._enabled) return; // Already enabled

		this._enabled = true;
		if (this.$inputElement) {
			console.log('Barcode scanner enabled');
			this.$inputElement.scannerDetection(this.scannerOptions);
			this.$inputElement.on('blur', this.onBlurHandler);
			this.$inputElement.on('paste', this.onPasteHandler);
			this.$inputElement.on('keydown', this.onKeydownHandler);
		}
	},

	disable: function() {
		if (!this._enabled) return; // Already disabled

		this._enabled = false;
		if (this.$inputElement) {
			console.log('Barcode scanner disabled');
			this.$inputElement.scannerDetection(false);
			this.$inputElement.off('blur', this.onBlurHandler);
			this.$inputElement.off('paste', this.onPasteHandler);
			this.$inputElement.off('keydown', this.onKeydownHandler);
		}
	},

	isEnabled: function() {
		return this._enabled;
	}
};
/*
###onComplete Default: false Callback after detection of a successful scanning
###onError Default: false Callback after detection of a unsuccessful scanning (scanned string in parameter)
###onReceive Default: false Callback after receiving and processing a char (scanned char in parameter)
###onKeyDetect Default: false Callback after detecting a keyDown (key char in parameter) - in contrast to onReceive, this fires for non-character keys like tab, arrows, etc. too!
###onScanButtonLongPressed Default: false Callback after detection of a successfull scan while the scan button was pressed and held down. This can only be used if the scan button behaves as a key itself (see scanButtonKeyCode). This long press event can be used to add a secondary action. For example, if the primary action is to count some items with barcodes (e.g. products at goods-in), it is comes very handy if a number pad pops up on the screen when the scan button is held. Large number can then be easily typed it instead of scanning fifty times in a row. Note: this option requires scanButtonKeyCode to be set to a valid key code!
###timeBeforeScanTest Default: 100 Wait duration (ms) after keypress event to check if scanning is finished
###avgTimeByChar Default: 30 Average time (ms) between 2 chars. Used to do difference between keyboard typing and scanning
###minLength Default: 6 Minimum length for a scanning
###endChar Default: [9,13] Chars to remove and means end of scanning
###startChar Default: [] Chars to remove and means start of scanning
###ignoreIfFocusOn Default: false Ignore scans if the currently focused element matches this selector. Per example, if you set this option to 'input', scanner detection will be disable if an input is focused, when the scan occurs.
###scanButtonKeyCode Default: false Key code of the scanner hardware button (if the scanner button a acts as a key itself). Knowing this key code is important, because it is not part of the scanned code and must be ignored. On the other hand, knowing it can be usefull: pressing the button multiple times fast normally results just in one scan, but you still could count the number of times pressed, allowing the user to input quantities this way (typical use case would be counting product at goods-in).
###scanButtonLongPressThreshold Default: 3 You can let the user perform some special action by pressing and holding the scan button. In this case the button will issue multiple keydown events. This parameter sets, how many sequential events should be interpreted as holding the button down.
###stopPropagation Default: false Stop immediate propagation on keypress event
###preventDefault Default: false Prevent default action on keypress event
*/


/*
 * jQuery Scanner Detection
 *
 * Copyright (c) 2013 Julien Maurel
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 * https://github.com/julien-maurel/jQuery-Scanner-Detection
 *
 * Version: 1.2.1
 *
 */

/*
 * Mod	Date			Description
 * 001	1/10/2018	Various modifications to support both keyboard input and scanning.  preventDefault has been redefined such that when set true,
 *							only scanner input is suppressed from appearing in input fields.  Previously, setting preventDefault to true suppressed all
 *							input, both typed in and scanner.
 *
 */
(function($){
	$.fn.scannerDetection=function(options){

		// If string given, call onComplete callback
		if(typeof options==="string"){
			this.each(function(){
                if(typeof this.scannerDetectionTest === "function") {
				    this.scannerDetectionTest(options);
                }
			});
			return this;
		}

		// If false (boolean) given, deinitialize plugin
		if(options === false){
			this.each(function(){
                if(typeof this.scannerDetectionOff === "function") {
				    this.scannerDetectionOff();
                }
			});
			return this;
		}

		var defaults={
			onComplete:false, // Callback after detection of a successfull scanning (scanned string in parameter)
			onError:false, // Callback after detection of a unsuccessfull scanning (scanned string in parameter)
			onReceive:false, // Callback after receiving and processing a char (scanned char in parameter)
			onKeyDetect:false, // Callback after detecting a keyDown (key char in parameter) - in contrast to onReceive, this fires for non-character keys like tab, arrows, etc. too!
			timeBeforeScanTest:100, // Wait duration (ms) after keypress event to check if scanning is finished
			avgTimeByChar:30, // Average time (ms) between 2 chars. Used to do difference between keyboard typing and scanning
			minLength:6, // Minimum length for a scanning
			endChar:[9,13], // Chars to remove and means end of scanning
			startChar:[], // Chars to remove and means start of scanning
			ignoreIfFocusOn:false, // do not handle scans if the currently focused element matches this selector
			scanButtonKeyCode:false, // Key code of the scanner hardware button (if the scanner button a acts as a key itself)
			scanButtonLongPressThreshold:3, // How many times the hardware button should issue a pressed event before a barcode is read to detect a longpress
			onScanButtonLongPressed:false, // Callback after detection of a successfull scan while the scan button was pressed and held down
			stopPropagation:false, // Stop immediate propagation on keypress event
			preventDefault:false // Prevent default action on keypress event
		};
		if(typeof options==="function"){
			options={onComplete:options}
		}
		if(typeof options!=="object"){
			options=$.extend({},defaults);
		}else{
			options=$.extend({},defaults,options);
		}

		this.each(function(){
			var self=this, $self=$(self), firstCharTime=0, lastCharTime=0, stringWriting='', callIsScanner=false, testTimer=false, scanButtonCounter=0;
			var initScannerDetection=function(){
				firstCharTime=0;
				stringWriting='';
				scanButtonCounter=0;
			};
			self.scannerDetectionOff=function(){
				$self.unbind('keydown.scannerDetection');
				$self.unbind('keypress.scannerDetection');
			}
			self.isFocusOnIgnoredElement=function(){
				if(!options.ignoreIfFocusOn) return false;
				if(typeof options.ignoreIfFocusOn === 'string') return $(':focus').is(options.ignoreIfFocusOn);
				if(typeof options.ignoreIfFocusOn === 'object' && options.ignoreIfFocusOn.length){
					var focused=$(':focus');
					for(var i=0; i<options.ignoreIfFocusOn.length; i++){
						if(focused.is(options.ignoreIfFocusOn[i])){
							return true;
						}
					}
				}
				return false;
			}
			self.scannerDetectionTest=function(s){
				// If string is given, test it
				if(s){
					firstCharTime=lastCharTime=0;
					stringWriting=s;
				}

				if (!scanButtonCounter){
					scanButtonCounter = 1;
				}

				// If all condition are good (length, time...), call the callback and re-initialize the plugin for next scanning
				// Else, just re-initialize
				if(stringWriting.length>=options.minLength && lastCharTime-firstCharTime<stringWriting.length*options.avgTimeByChar){
					if(options.onScanButtonLongPressed && scanButtonCounter > options.scanButtonLongPressThreshold) options.onScanButtonLongPressed.call(self,stringWriting,scanButtonCounter);
					else if(options.onComplete) options.onComplete.call(self,stringWriting,scanButtonCounter);
					$self.trigger('scannerDetectionComplete',{string:stringWriting});
					initScannerDetection();
					return true;
				}else{
					if(options.onError) options.onError.call(self,stringWriting);
					$self.trigger('scannerDetectionError',{string:stringWriting});
					initScannerDetection();
					return false;
				}
			}
			$self.data('scannerDetection',{options:options}).unbind('.scannerDetection').bind('keydown.scannerDetection',function(e){
				// If it's just the button of the scanner, ignore it and wait for the real input
				if(options.scanButtonKeyCode !== false && e.which==options.scanButtonKeyCode) {
					scanButtonCounter++;
					// Cancel default
					e.preventDefault();
					e.stopImmediatePropagation();
				}
					// Add event on keydown because keypress is not triggered for non character keys (tab, up, down...)
				// So need that to check endChar and startChar (that is often tab or enter) and call keypress if necessary
				else if((firstCharTime && options.endChar.indexOf(e.which)!==-1)
					|| (!firstCharTime && options.startChar.indexOf(e.which)!==-1)){
					// Clone event, set type and trigger it
					var e2=jQuery.Event('keypress',e);
					e2.type='keypress.scannerDetection';
					$self.triggerHandler(e2);
					// Cancel default
					e.preventDefault();
					e.stopImmediatePropagation();
				}
				// Fire keyDetect event in any case!
				if(options.onKeyDetect) options.onKeyDetect.call(self,e);
				$self.trigger('scannerDetectionKeyDetect',{evt:e});

			}).bind('keypress.scannerDetection',function(e){
				if (this.isFocusOnIgnoredElement()) return;
				if (options.stopPropagation) e.stopImmediatePropagation();

				// 001
				//	Prevent default key handling only when scanning.
				if (firstCharTime && options.preventDefault) e.preventDefault();

				if(firstCharTime && options.endChar.indexOf(e.which)!==-1){
					e.preventDefault();
					e.stopImmediatePropagation();
					callIsScanner=true;
				}else if(!firstCharTime && options.startChar.indexOf(e.which)!==-1){
					e.preventDefault();
					e.stopImmediatePropagation();
					callIsScanner = false;

					// 001
					// firstCharTime was being set unconditionally below.  changed this so that only
					// set when the prefix character is encountered
					firstCharTime = Date.now();

				} else {
					// 001
					// Only add to the scanned string if the scan prefix has been encountered.
					if (firstCharTime && (typeof(e.which) != 'undefined')){
						stringWriting+=String.fromCharCode(e.which);
					}
					callIsScanner=false;
				}
				//  001
				//  FirstCharTime now set above only when the prefix character is encountered.  this resolves issues
				//  with typed-in characters being discarded when typed rapidly
				//if(!firstCharTime){
				//    firstCharTime=Date.now();
				//}
				lastCharTime=Date.now();

				if(testTimer) clearTimeout(testTimer);
				if(callIsScanner){
					self.scannerDetectionTest();
					testTimer=false;
					// 001
					// only set timer after scan prefix has been detected.
					//} else {
				} else if (firstCharTime) {
					testTimer=setTimeout(self.scannerDetectionTest,options.timeBeforeScanTest);
				}

				if(options.onReceive) options.onReceive.call(self,e);
				$self.trigger('scannerDetectionReceive',{evt:e});
			});
		});
		return this;
	}
})(jQuery);

(function ($) {
	$.fn.trimval = function() {
		var val = $.fn.val.call(this);
		return val.trim();
	};
})(jQuery);

(function ($) {
	$.fn.cursorFocus = function() {
		var x = window.scrollX, y = window.scrollY;
		this.focus();
		window.scrollTo(x, y);
	};
})(jQuery);

module.exports = barcode;

function microtime(getAsFloat, getAsInt) {
	var s, now, multiplier;

	if(typeof performance !== 'undefined' && performance.now) {
		now = (performance.now() + performance.timing.navigationStart) / 1000;
		multiplier = 1e6; // 1,000,000 for microseconds
	}
	else {
		now = (Date.now ? Date.now() : new Date().getTime()) / 1000;
		multiplier = 1e3; // 1,000
	}

	// Getting microtime as a float is easy
	if(getAsFloat) {
		return now;
	}

	if(getAsInt) {
		now = now * 1000;
		now = Math.round(now);
		return now;
	}

	// Dirty trick to only get the integer part
	s = now | 0;

	return (Math.round((now - s) * multiplier ) / multiplier ) + ' ' + s;
}

Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};